// 크레딧 조정 공통 순수 로직 (P3, 2026-09-17) — desktop(TopUsersTable/CxSection QuickAdjust)과
// 모바일(MobileCreditAdjustSheet)이 같은 검증·계산·위험판정 규칙을 공유한다(중복 방지).
// I/O 없음(순수 함수) — 테스트 용이.

// 대액 임계(기존 desktop 값과 일치). 이 이상이거나 잔액이 음수가 되면 danger 강조 + 재확인.
export const LARGE_AMOUNT_THRESHOLD = 100_000;

// 사유 최소 길이(기존 desktop 값과 일치).
export const MIN_REASON_LEN = 3;

// sign: 1(지급) | -1(회수). mag: 절대 조정량(정수>0). 반환 signed 조정액(부호 포함).
export function signedAmount(sign, mag) {
  return (sign || 0) * (Number(mag) || 0);
}

// 유효성 — { validMag, validReason, valid }.
export function validateCreditAdjust({ mag, reason }) {
  const n = Number(mag);
  const validMag = Number.isInteger(n) && n > 0;
  const validReason = (reason || "").trim().length >= MIN_REASON_LEN;
  return { validMag, validReason, valid: validMag && validReason };
}

// 예상 변경 후 잔액. balance/signed 가 유효하지 않으면 null.
export function computeExpectedBalance(balance, signed) {
  if (typeof balance !== "number" || !Number.isFinite(signed)) return null;
  return balance + signed;
}

// 위험 조정 여부(재확인 필요) — 대액이거나 잔액이 음수가 되는 경우.
export function isRiskyAdjustment({ mag, expected }) {
  const n = Number(mag);
  const validMag = Number.isInteger(n) && n > 0;
  return validMag && (n >= LARGE_AMOUNT_THRESHOLD || (expected != null && expected < 0));
}
